import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  Card,
  Badge,
  Carousel,
  Menu,
  Breadcrumb,
  Dropdown,
  Button,
  Spin,
  notification,
  Input,
  message,
} from "antd";
import {
  FaCrown,
  FaHeart,
  FaKickstarter,
  FaRegHeart,
  FaStar,
  FaStarHalfAlt,
  FaThumbsUp,
  FaWhatsapp,
} from "react-icons/fa";
import { BiLeftArrow, BiPhoneCall, BiRightArrow } from "react-icons/bi";
import { EnvironmentOutlined } from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { CgMenu } from "react-icons/cg";
import verifiedlogo from "../../../../assets/frontendassets/Verification Icons/1.png";
import trustedLogo from "../../../../assets/frontendassets/Verification Icons/2.png";
import physicalLogo from "../../../../assets/frontendassets/Verification Icons/3.png";
import TopRated from "../../../../assets/frontendassets/Verification Icons/4.png";
import png23 from "../../../../assets/frontendassets/Verification Icons/3.png";
import { AuthContext } from "../../../Auth/AuthContext";
import statesData from "./../../Home/states.json";
import { getAllBusiness, getAllcategories, getSliderForUsers } from "../../../../utils/API";
import { detectCountryCodeForHome } from "../../../../utils/setting";

interface StateOption {
  label: string;
  value: string;
}

const CategoryBusiness = () => {
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [businessdata, setBusinessData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const [verifiedFilter, setVerifiedFilter] = useState(false);
  const [trustedFilter, setTrustedFilter] = useState(false);
  const [topRatedFilter, setTopRatedFilter] = useState(false);
  const [physicallyVerifiedFilter, setPhysicallyVerifiedFilter] =
    useState(false);
  const location = useLocation(); // Initialize useLocation
  const searchParams = new URLSearchParams(location.search);
  const category = searchParams.get("category");
  const country = searchParams.get("country");
  const [wishlist, setWishlist] = useState<any>([]);
  const state = searchParams.get("state"); // Retrieve state parameter
  const imageUrl = process.env.REACT_APP_IMAGE_URL + "/businesse/";
  const sliderImageUrl = process.env.REACT_APP_IMAGE_URL + "/sliders/";
  const [categories, setCategories] = useState<any[]>([]);
  const [states] = useState<StateOption[]>(
    statesData.map((state) => ({ label: state.label, value: state.label }))
  );
  const { authData } = useContext(AuthContext);
  const isLoggedIn = authData?.token;
  const userId = authData?.user?._id;
  // const [isNumberVisible, setIsNumberVisible] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState<string | null>(null);
  const [sliders , setSliders ] = useState<any>([])
  const [visibleNumbers, setVisibleNumbers] = useState<{
    [key: string]: boolean;
  }>({});
  const [isLogged, setIsLogged] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  
const [selectedCategory, setSelectedCategory] = useState<any>(category || null);
const [selectedState, setSelectedState] = useState<any>(state || null);
const [selectedCountry, setSelectedCountry] = useState<any>(country || null);
  const [ratingFilter, setRatingFilter] = useState<number | null>(null); // Filter by specific rating threshold
  const [sortingOrder, setSortingOrder] = useState<string>(""); // Sorting order: 'asc' or 'desc'

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await getAllcategories();
      const filteredCategories = response.filter(
        (category: any) => !category.categoryId && !category.isDeleted
      );
      setCategories(filteredCategories);
    } catch (error) {
      message.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // useEffect(() => {
  //   const fetchCountryCode = async () => {
  //     const countryName = await detectCountryCodeForHome(); // Get country name
  //     setSelectedCountry(countryName);
  //     console.log("Detected Country:", countryName);
  //   };
  //   fetchCountryCode();
  // }, []);

  useEffect(() => {
    // Check login state from localStorage
    const loginState = localStorage.getItem("isRapidexieLogin") === "true";
    setIsLogged(loginState); // Update the state
    console.log("loginState", loginState);
  }, []);

  const handleToggleNumberVisibility = (slug: string) => {
    setVisibleNumbers((prevState) => ({
      ...prevState,
      [slug]: !prevState[slug],
    }));
  };

  const handleClick = (e: any) => {
    if (!phoneNumber) {
      e.preventDefault(); // Prevent navigation
      setIsFormValid(false);
    } else {
      setIsFormValid(true); // Clear error if valid
    }
  };  

  const mobileNumbersArray = mobileNumber ? [mobileNumber] : [];

  const handleGetBusiness = async (
    page: number = 1,
    category?: string | null,
    state?: string | null,
    country?: string | null
  ) => {
    setLoading(true);
    try {
      const res = await getAllBusiness(page, category, state , "" , verifiedFilter ? "true" : "" , trustedFilter ? "true" : "" , topRatedFilter ? "true" : "", physicallyVerifiedFilter ? "true" : "" , country );
      setBusinessData((prevData: any) =>
        page === 1 ? res.data : [...prevData, ...res.data]
      ); // Reset or append data
      setTotalPages(res.totalPages);
      setCurrentPage(res.currentPage);
    } catch (error) {
      console.error("Failed to fetch business data", error);
    } finally {
      setLoading(false);
    }
  };
  console.log(businessdata);
  // Filter Businesses based on Verified and Trusted
  const filterBusinessData = (data: any) => {
    let filteredData = [...data];
  
    // Apply Verified Filter
    if (verifiedFilter) {
      filteredData = filteredData.filter((business) => business.isVerified);
    }
  
    // Apply Trusted Filter
    if (trustedFilter) {
      filteredData = filteredData.filter((business) => business.isTrusted);
    }
  
    // Apply Top Rated Filter
    if (topRatedFilter) {
      filteredData = filteredData.sort((a, b) => b.averageRating - a.averageRating);
    }
  
    // Apply Physically Verified Filter
    if (physicallyVerifiedFilter) {
      filteredData = filteredData.filter((business) => business.isPhysicallyVerified);
    }
  
  if (ratingFilter) {
    filteredData = filteredData.filter((business) => business.averageRating >= ratingFilter);
  }
  
    // Sorting by Rating
    if (sortingOrder === "asc") {
      filteredData = filteredData.sort((a, b) => a.averageRating - b.averageRating);
    } else if (sortingOrder === "desc") {
      filteredData = filteredData.sort((a, b) => b.averageRating - a.averageRating);
    }
  
    return filteredData;
  };
  

  const filteredData = useMemo(
    () => filterBusinessData(businessdata),
    [
      businessdata,
      verifiedFilter,
      trustedFilter,
      topRatedFilter,
      physicallyVerifiedFilter,
        ratingFilter,
        sortingOrder
    ]
  );

    useEffect(() => {
      // Check if there is a stored scroll position and page
      const savedScrollPosition = sessionStorage.getItem("scrollPosition");
      const savedPage : any = sessionStorage.getItem("currentPage");
      console.log("savedPage", savedPage);
  
      if (savedPage) {
        setCurrentPage(parseInt(savedPage, 10));
      }
      console.log("currentPage123", currentPage);
      handleGetBusiness(savedPage , selectedCategory, selectedState , selectedCountry); // Fetch API for the current page
      if (savedScrollPosition) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollPosition, 10));
        }, 500); // Slight delay to ensure smooth scroll restoration
      }
    }, [currentPage]);
  

  useEffect(() => {
    handleGetBusiness(1, selectedCategory, selectedState , selectedCountry);
  }, [selectedCategory, selectedState , verifiedFilter, trustedFilter, topRatedFilter, physicallyVerifiedFilter , selectedCountry]);

  useEffect(() => {
    // Update state from URL whenever the component mounts or the URL changes
    setSelectedCategory(category || null);
    setSelectedState(state || null);
    setSelectedCountry(country || null);
  }, [category, state]);
  

  const handleLoadMore = async () => {
    if (currentPage >= totalPages) return; // Prevent unnecessary calls
    setLoading(true);
    try {
      const nextPage = currentPage + 1;
      await handleGetBusiness(nextPage , selectedCategory, selectedState , selectedCountry); // Fetch next page data
      setCurrentPage(nextPage); // Update the current page
    } catch (error) {
      console.error("Error loading more data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSliders = async () => {
    try {
      const response = await getSliderForUsers(); // Add 'await' to resolve the promise
      console.log("response", response);
      setSliders(response); // Set the sliders state with resolved data
      return response; // Return the resolved data if needed
    } catch (error) {
      console.error("Error fetching sliders:", error);
      throw error;
    }
  };
  

  useEffect(() => {
    getSliders();
  }, [])

  const NextArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <BiRightArrow
        className={className}
        style={{
          ...style,
          fontSize: "24px",
          color: "#FFF",
          borderTopLeftRadius: "5px",
          borderBottomLeftRadius: "5px",
          position: "absolute",
          right: "0px",
          top: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 0.5,
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={onClick}
      />
    );
  };

  const PrevArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <BiLeftArrow
        className={`${className} ${showRightArrow ? "block" : "hidden"}`}
        style={{
          ...style,
          fontSize: "24px",
          color: "#FFF",
          borderTopRightRadius: "5px",
          borderBottomRightRadius: "5px",
          position: "absolute",
          left: "0px",
          top: "50%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 0.5,
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
        onClick={onClick}
      />
    );
  };

  const calculateBusinessAge = (createdAt: any) => {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
    // console.log('createdDate',createdDate)
    const diffYears = currentDate.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      currentDate.getMonth() - createdDate.getMonth() + diffYears * 12;
    // console.log('diffMonths',diffMonths)
    const years = Math.floor(diffMonths / 12);
    const months = diffMonths % 12;
    // console.log('gfgfgdg',years, months)
    return years > 0
      ? `${years} yrs${years > 1 ? "" : ""} ${months} mth${
          months > 1 ? "" : ""
        } in business`
      : `${months} mth${months > 1 ? "" : ""} in business`;
  };

  return (
    <div className="pt-6  bg-[#FFF8EC]">
   <div className="xl:pl-10 xl:pr-10">
  <Row className="pt-4 pb-4">
    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={8} className="p-2">
      <div className="flex items-center md:px-3 xl:px-6 w-full">
        <select
          className="bg-[#FDF1DD] text-gray-800 px-2 appearance-none h-[57px] outline-none rounded-lg w-full text-left pl-3"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">Select a category</option>
          {categories.map((category) => (
            <option key={category._id} value={category._id}>
              {category.name}
            </option>
          ))}
        </select>
      </div>
    </Col>
    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={8} className="p-2">
      <div className="flex items-center md:px-3 xl:px-6 w-full">
        <select
          className="bg-[#FDF1DD] text-gray-800 px-2 appearance-none h-[57px] outline-none rounded-lg w-full text-left pl-3"
          value={selectedState || ""}
          onChange={(e) => setSelectedState(e.target.value || null)}
        >
          <option value="">Select a state</option>
          {states.map((state) => (
            <option key={state.value} value={state.value}>
              {state.label}
            </option>
          ))}
        </select>
      </div>
    </Col>
  </Row>
</div>


<div className="py-2">
   <Carousel
                    dots={false}
                    arrows
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                    draggable
                    autoplay
                    autoplaySpeed={3000}
                >
                    {sliders.map((image: any, imgIndex: any) => (
                      <a href={`tel:${image.mobileNumber}`} key={imgIndex}>
                      <img
                      className="h-auto sm:h-auto md:h-auto lg:h-auto xl:h-[214px] w-full object-contain rounded-xl"
                      src={`${sliderImageUrl}${image.image}`}
                      alt={`Carousel ${imgIndex}`}
                    />
                    </a>
                    ))}
                  </Carousel>
                 
</div>

      <div className="md:pl-6 md:pr-6">
      <div className="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-6 md:gap-12 p-4 rounded-lg text-[10px] sm:text-[16px] md:text-[13px] text-center sm:text-start">
      {/* Sorting */}
      <div className="flex items-center w-full" style={{ flex: "1 1 0" }}>
        <select
          className="bg-[#FDF1DD] text-gray-800 px-2 appearance-none xl:h-[57px] outline-none rounded-lg w-full text-left"
          onChange={(e) => setSortingOrder(e.target.value)}
        >
          <option value="">Sort by</option>
          <option value="asc">Low to High</option>
          <option value="desc">High to Low</option>
        </select>
      </div>

      {/* Rating Filter */}
      <div className="flex items-center w-full" style={{ flex: "1 1 0" }}>
        <select
          className="bg-[#FDF1DD] text-gray-800 px-2 appearance-none xl:h-[57px] outline-none rounded-lg w-full text-left"
          onChange={(e) => setRatingFilter(Number(e.target.value))}
        >
          <option value="">Rated</option>
          <option value="5">5 Stars</option>
          <option value="4">4 Stars</option>
          <option value="3">3 Stars</option>
          <option value="2">2 Stars</option>
          <option value="1">1 Star</option>
        </select>
      </div>

      {/* Top Rated Filter */}
      <button
        onClick={() => setTopRatedFilter((prev) => !prev)}
        className={`${
          topRatedFilter ? "bg-[#F9B138]" : "bg-[#FDF1DD]"
        } flex items-center justify-center border-1 border-black rounded-md space-x-2 p-1`}
      >
        <img src={TopRated} className="w-7 h-7" alt="Top Rated" />
        <div>Top Rated</div>
      </button>

      {/* Verified Stamp Filter */}
      <button
        onClick={() => setVerifiedFilter((prev) => !prev)}
        className={`${
          verifiedFilter ? "bg-[#F9B138]" : "bg-[#FDF1DD]"
        } flex items-center justify-center border-1 border-black rounded-md space-x-2 p-1`}
      >
        <img src={verifiedlogo} className="w-7 h-7" alt="Verified Stamp" />
        <div>Verified Stamp</div>
      </button>

      {/* TrustSEAL Filter */}
      <button
        onClick={() => setTrustedFilter((prev) => !prev)}
        className={`${
          trustedFilter ? "bg-[#F9B138]" : "bg-[#FDF1DD]"
        } flex items-center justify-center border-1 border-black rounded-md space-x-2 p-1`}
      >
        <img src={physicalLogo} className="w-7 h-7" alt="TrustSEAL" />
        <div>TrustSEAL</div>
      </button>

      {/* Physically Verified Filter */}
      <button
        onClick={() => setPhysicallyVerifiedFilter((prev) => !prev)}
        className={`${
          physicallyVerifiedFilter ? "bg-[#F9B138]" : "bg-[#FDF1DD]"
        } flex items-center justify-center border-1 border-black rounded-md space-x-2 p-1`}
      >
        <img src={trustedLogo} className="w-7 h-7" alt="Physically Verified" />
        <div>Physically Verified</div>
      </button>
    </div>
      </div>
      <InfiniteScroll
        dataLength={businessdata.length} // This determines when InfiniteScroll triggers the next fetch
        next={handleLoadMore}
        hasMore={currentPage < totalPages} // Stops fetching when no more pages
        loader={<></>}
        className="pb-12"
      >
        {filteredData.length > 0 ? (
          filteredData.map((business: any, index: any) => (
            <div key={index} className="xl:pl-12 2xl:pl-12 sm:p-8 lg:pl-12 lg:pr-12 pl-2 pr-2 xl:pr-12 2xl:pr-12 mt-8">
              <Row gutter={8}>
                <Col
                              xs={24}
                              sm={24}
                              md={10}
                              lg={10}
                              xl={9}
                              xxl={9}
                              className="cursor-pointer"
                              onClick={() => navigate(`/business/${business.slug}`)}
                            >
                  <Carousel
                    dots={false}
                    arrows
                    nextArrow={<NextArrow />}
                    prevArrow={<PrevArrow />}
                    draggable
                    autoplay
                    autoplaySpeed={3000}
                    beforeChange={(from, to) => {
                      if (from === 1 && to === 2) {
                        setShowRightArrow(true);
                      }
                    }}
                  >
                    {business.galleryImage.map((image: any, imgIndex: any) => (
                      <img
                        className="h-48 sm:h-80 md:h-80 lg:h-48 xl:h-[324px] w-full object-cover rounded-xl"
                        src={`${imageUrl}${image}`}
                        alt={`Carousel ${imgIndex}`}
                      />
                    ))}
                  </Carousel>
                </Col>
            <Col xs={24} sm={24} md={14} lg={14} xl={8} className="xs:p-3 md:p-5 lg:p-5">
                  <div className="flex md:pl-4 lg:pl-4 justify-between items-center md:pt-0 lg:pt-0 xl:pt-0 2xl:pt-0" 
                   onClick={() => navigate(`/business/${business.slug}`)}
                  >
                    <div className="flex items-center">
                      {/* <FaThumbsUp className="text-yellow-500" size={20} /> */}
                      <p className="text-black   text-[30px] sm:text-2xl hover:text-yellow-500  cursor-pointer">
                        {business.businessName}
                      </p>
                    </div>

                    <div></div>
                  </div>
                  <div className="flex  md:pl-4 lg:pl-4 flex-wrap items-center pt-2">
                    <span className="text-sm rounded-md pl-1 pr-1 tracking-widest bg-[#118601] text-white">
                      <span className=" flex text-sm items-center font-semibold pl-1 py-1 pr-1">
                        <FaStar className="text-yellow-500" size={16} />
                        &nbsp;&nbsp;
                        {business.averageRating != null
                          ? parseFloat(business.averageRating).toFixed(1)
                          : "0"}
                      </span>
                    </span>

                    <div className="flex md:pl-4 lg:pl-4 items-center">
                      {/* {business.reviews.length} ratings  */}
                      <span className="ml-2 text-gray-600 font-medium">
                        {business.reviews.length} ratings
                      </span>
                    </div>
                  </div>
                  <div className="flex md:pl-4 lg:pl-4 items-center space-x-3 ms-2 pt-3">
                    {business.isVerified === 2 && (
                      <div className="flex items-center space-x-1 ">
                        <img
                          src={verifiedlogo}
                          alt="logo"
                          className="w-8 h-8"
                        />
                        {/* <p className="text-normal font-medium text-white bg-blue-500 px-2 py-1">Verified</p> */}
                      </div>
                    )}
                    {business.isTrusted === 2 && (
                      <div className="flex items-center space-x-1">
                        <img
                          src={physicalLogo}
                          alt="logo"
                          className="w-8 h-8"
                        />
                        {/* <p className="text- font-medium text-white bg-yellow-700 px-2 py-1">Trusted</p> */}
                      </div>
                    )}
                    {business.isPhysicallyVerified === 1 && (
                      <div className="flex items-center space-x-1">
                        <img src={trustedLogo} alt="logo" className="w-8 h-8" />
                        {/* <p className="text- font-medium text-white bg-yellow-700 px-2 py-1">Trusted</p> */}
                      </div>
                    )}
                    {/* {
                      <div className="p-2 text-black text-[17px]">
                          {calculateBusinessAge(business.createdAt)}
                          </div>
                    } */}
                  </div>
                  <p className="pt-3 md:pl-4 lg:pl-4  font-semibold text-lg">Address</p>
                  <div className="flex md:pl-4 lg:pl-4 items-center pt-2 flex-wrap md:flex-nowrap">
                    {/* <EnvironmentOutlined
  size={20}
  className="pr-2 text-yellow-500 text-base"
/> */}

                    <p
                      className="text-[19px] leading-tight "
                      style={{ fontFamily: '"Roboto", sans-serif' }}
                    >
                      {`${business.buildingName}, ${business.streetName},${business.city}, ${business.state} ${business.pincode}`}
                    </p>
                  </div>

                  {/* <div className="flex items-center pt-3">
                  <Badge className="text-sm rounded-md pl-1 pr-1 px-2 py-1 bg-slate-200 text-gray-800">
                    {business.categoryId[0].name}
                  </Badge>
                </div> */}
        <div className="flex items-center md:pl-4 lg:pl-4 flex-wrap pt-3">
                                                         
                                                                 <Col
                                                                     xs={8}
                                                                     sm={8}
                                                                     md={4}
                                                                     lg={7}
                                                                     xl={7}
                                                                     xxl={7}
                                                                     className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                                                   >
                                                                     <a href={`tel:${business.mobileNumber}`} target="_blank" rel="noopener noreferrer">
                                                                       
                                                                     <button
                                                                       className="flex items-center h-[38px] justify-center space-x-1 px-1 py-1.5 rounded-md bg-[#118601] border-1 border-gray-900 text-white w-full text-md sm:text-md"
                                                                     >
                                                                       <BiPhoneCall className= "sm:text-[12px] lg:text-[19px]" color="white" fill="white" />
                                                                       <span className= "sm:text-[12px] lg:text-[19px]">call</span>
                                                                     </button>
                                                                     </a>
                                                                   </Col>
                                                                   <Col
                                                                     xs={8}
                                                                     sm={8}
                                                                     md={10}
                                                                     lg={10}
                                                                     xl={10}
                                                                     xxl={10}
                                                                     className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 md:ml-1 md:mr-1 w-auto"
                                                                   >
                                                                     <Link to={`/business/${business.slug}`}>
                                                                     <button
                                                                       className="flex items-center h-[38px] justify-center space-x-2 px-2 py-1.5 rounded-md  border-1 border-gray-900 text-black w-full text-md sm:text-md whitespace-nowrap"
                                                                     // onClick={handleEnquiryRedirect}
                                                                     >
                                                                       <FaStar className="text-yellow   sm:text-[12px] lg:text-[19px]" />
                                                                       <span className="truncate  sm:text-[12px] lg:text-[19px]">Write Review</span>
                                                                     </button>
                                                                     </Link>
                                                                   </Col>
                                                                   <Col
                                                                     xs={8}
                                                                     sm={8}
                                                                     md={5}
                                                                     lg={6}
                                                                     xl={6}
                                                                     xxl={6}
                                                                     className="mt-2 sm:mt-0 md:mt-0 lg:mt-0 xl:mt-0 w-[7rem]"
                                                                   >
                                                                     <Link to={`https://wa.me/${business.whatsappNumber}?text=I'm interested in ${business.businessName}`} target="_blank" rel="noopener noreferrer">
                                                                       
                                                                     <button
                                                                       className="flex items-center h-[38px] justify-center space-x-1 px-1 py-1.5 rounded-md  border-1 border-gray-900 text-gray-700 w-full text-md sm:text-md"
                                                                     >
                                                                       <FaWhatsapp className= "sm:text-[12px] lg:text-[19px]" color="green" fill="green" />
                                                                       <span className= "sm:text-[12px] lg:text-[19px]">Chat</span>
                                                                     </button>
                                                                     </Link>
                                                                   </Col>
                                                               
                          
                                            </div>

                </Col>
              </Row>
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center h-48">
            {loading ? (
              <Spin size="large" />
            ) : (
              <p className="text-xl text-gray-400"> No businesses found.</p>
            )}
          </div>
        )}
      </InfiniteScroll>

      {/* Load more button */}
      {currentPage < totalPages && (
        <div className="flex justify-center mt-4">
          <Button onClick={handleLoadMore} loading={loading}>
            Load More
          </Button>
        </div>
      )}
      {/* this is updated design  */}
    </div>
  );
};

export default CategoryBusiness;
